'use client'
import {
  Button_default
} from "./chunk-ZVR4LKK3.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/ToggleGroup/ToggleGroup.tsx
import { Fragment } from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { twMerge } from "tailwind-merge";
import { CloseIcon } from "@wbk/svg";
import { jsx, jsxs } from "react/jsx-runtime";
var ToggleGroup = ({
  type,
  name,
  label,
  options,
  value,
  onChange,
  rounded = true,
  error,
  disabled,
  groupClassName,
  className,
  dir,
  phill = false,
  hideErrorSpace = true,
  separator,
  activeBtnProps,
  btnProps,
  variant = "default",
  showClose = false,
  ref
}) => {
  const isMultiple = type === "multiple" || Array.isArray(value);
  return /* @__PURE__ */ jsxs(
    ToggleGroupPrimitive.Root,
    __spreadProps(__spreadValues({}, isMultiple ? {
      type: "multiple",
      value,
      onValueChange: onChange
    } : { type: "single", value, onValueChange: onChange }), {
      dir,
      disabled,
      ref,
      children: [
        label && /* @__PURE__ */ jsx("label", { className: `block pb-1 ${disabled ? "text-text-disabled" : ""}`, children: label }),
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-variant": variant,
            className: twMerge(
              "data-[variant=stacked]:bg-body-level-1 flex w-full flex-wrap gap-2 data-[variant=stacked]:flex-nowrap data-[variant=stacked]:p-1",
              phill ? "rounded-full" : "rounded-md",
              groupClassName
            ),
            children: options.map((op, i) => {
              const isActive = isMultiple ? value == null ? void 0 : value.includes(op.value) : value === op.value;
              return /* @__PURE__ */ jsxs(Fragment, { children: [
                i > 0 && separator,
                /* @__PURE__ */ jsx(
                  ToggleGroupPrimitive.Item,
                  {
                    name,
                    disabled: disabled || op.disabled,
                    asChild: true,
                    "data-testid": `ui_toggle_${name}_${op.value}`,
                    value: op.value,
                    children: /* @__PURE__ */ jsxs(
                      Button_default,
                      __spreadProps(__spreadValues({
                        rounded,
                        phill
                      }, isActive ? __spreadValues({ theme: "primary" }, activeBtnProps) : __spreadValues({ theme: "action", shape: "outlined" }, btnProps)), {
                        className: twMerge(
                          "max-w-fit flex-1",
                          className,
                          isActive ? activeBtnProps == null ? void 0 : activeBtnProps.className : btnProps == null ? void 0 : btnProps.className
                        ),
                        children: [
                          !!op.icon && typeof op.icon === "string" ? /* @__PURE__ */ jsx(
                            "img",
                            {
                              src: op.icon,
                              width: 22,
                              height: 22,
                              alt: typeof op.text === "string" ? op.text : op.value,
                              className: "shrink-0 pr-4"
                            }
                          ) : op.icon,
                          /* @__PURE__ */ jsx("div", { children: op.text }),
                          showClose && isActive && /* @__PURE__ */ jsx(CloseIcon, { className: "h-3 w-3 shrink-0" }),
                          op.description && /* @__PURE__ */ jsx("div", { className: "text-text inline group-data-[state=on]:text-sky-100", children: op.description })
                        ]
                      })
                    )
                  },
                  op.value
                )
              ] }, i);
            })
          }
        ),
        (typeof error === "string" && !!error || !hideErrorSpace) && /* @__PURE__ */ jsx(
          "p",
          {
            className: `text-error my-1 min-h-[16px] text-xs ${error ? "visible" : "text-transparent"}`,
            children: error
          }
        )
      ]
    })
  );
};
var ToggleGroup_default = ToggleGroup;

export {
  ToggleGroup_default
};
//# sourceMappingURL=chunk-7PU6GJRY.mjs.map